import NextDepartures from './next_departures';

export default NextDepartures;
